<template>
  <div class="home-view">
    <div class="icon-title-container">
      <img id="home-icon" src="/images/football.png" alt="football"/>
      <h2>主页</h2>
    </div>

    <div class="footviz-container">
      <h1 class="footviz-title">欢迎来到 FootViz</h1>
      <p class="footviz-subtitle">专为足球爱好者、教练员与数据分析师打造的比赛数据可视化平台</p>

      <p class="footviz-text">
        在这个每一个进球都可能决定胜负的竞技世界，单靠比分远远不够。FootViz 带你深入比赛背后，通过
        <strong>球员数据分析</strong> 和 <strong>球队整体表现可视化</strong>，帮助你全面理解比赛动态与战术布置。
      </p>

      <p class="footviz-text">
        无论你是热爱足球的球迷、精益求精的教练，还是追求洞察的分析师，FootViz 都能让你：
      </p>

      <ul class="footviz-features">
        <li>⚽ 快速洞察比赛走势与关键数据</li>
        <li>📊 多维度比较球员与球队表现</li>
        <li>🧠 为战术分析与人员安排提供数据支撑</li>
      </ul>

      <p class="footviz-footer">
        借助图表、热图和交互式可视化工具，一起用数据看懂足球，让分析更精准，让热爱更深入。
      </p>
    </div>
  </div>
</template>

<script setup>
// No script logic needed for this static page yet
</script>

<style scoped>
/* You can copy styles from your original stylesheet or create new ones */
.home-view {
  padding: 20px;
}
.footviz-container {
  max-width: 800px;
  margin: 2rem auto;
  padding: 2rem;
  background-color: #f9f9f9;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.footviz-title {
  text-align: center;
}
.footviz-subtitle {
  text-align: center;
  color: #666;
}
.icon-title-container {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}
#home-icon {
    width: 40px;
    height: 40px;
    margin-right: 15px;
}
</style>
